import classNames from 'classnames'
import React from 'react'
import { format } from 'currency-formatter'
import { Card } from './Card'

import styles from './Cards.module.scss'

interface CardsProps {
  title: React.ReactNode
  count: number
  total?: number
  className?: string
  classes?: {
    card?: string
    total?: string
  }
}

export const Cards: React.FC<CardsProps> = ({
  title,
  count,
  total,
  className,
  classes,
}) => {
  const value = format(count, { thousand: '.', precision: 0 })
  const percentage =
    total != null && total > 0 ? Math.round((count / total) * 100) : null

  return (
    <Card
      className={className}
      cardClassName={classNames(classes?.card || styles.default)}
    >
      <div className={styles.content}>{title}</div>
      <div className={classNames(styles.total, classes?.total)}>
        <span>{value}</span>
        {percentage !== null && (
          <span className={styles.percentage}>({percentage}%)</span>
        )}
      </div>
    </Card>
  )
}

export default Cards
